import { Text } from '@stitch-fix/mode-react';
import { Link } from '@stitch-fix/sf-next';
export type SignInPromptProps = {
  signInUrl?: string;
};
export const SignInPrompt = ({
  signInUrl = '/login'
}: SignInPromptProps) => {
  return <Text as="p" setting="body-small-fixed" mt={1}>
      Already have an account? <Link href={signInUrl}>Sign in</Link>
    </Text>;
};